<script lang="ts">
    import cn from 'classnames';
    import { Size } from '@uikit/types';
    import s from './link.module.css';
    import { type Props, Color } from './types';

    export let classes: Props['classes'] = '';
    export let isUnderline: Props['isUnderline'] = false;
    export let isDottedUnderline: Props['isDottedUnderline'] = false;
    export let isDisabled: Props['isDisabled'] = false;
    export let attrs: Props['attrs'] = {};
    export let href: Props['href'] = null;
    export let el: Props['el'] = null;
    export let size: Props['size'] = Size.Medium;
    export let isBold: Props['isBold'] = false;
    export let offVisited: Props['offVisited'] = false;
    export let withIconRight: Props['withIconRight'] = false;
    export let withIconLeft: Props['withIconLeft'] = false;
    export let target: Props['target'] = undefined;
    export let color: Props['color'] = Color.Primary;
    export let style: Props['style'] = undefined;

    $: rootClasses = cn(
        s.root,
        s[`${size}`],
        { [s.bold]: isBold },
        { [s.offVisited]: offVisited },
        { [s.underline]: isUnderline },
        { [s.dottedline]: isDottedUnderline },
        { [s.disabled]: isDisabled },
        { [s.withIconRight]: withIconRight },
        { [s.withIconLeft]: withIconLeft },
        color && s[color],
        classes,
    );
</script>

<svelte:element
    this={isDisabled || !href ? 'span' : 'a'}
    class={rootClasses}
    {style}
    {href}
    {target}
    on:click
    bind:this={el}
    {...attrs}
>
    <slot></slot>
</svelte:element>
